import axios from '@utils/axios';
import router from '@router/router';

const sampleDetail = {
  state: {
    sampleId: 0,
    status: 1,
    customerName: '',
    updatedAt: ''
  },
  mutations: {
    setSampleId(state, id) {
      state.sampleId = id;
    },
    setStatus(state, status) {
      state.status = status;
    },
    setUpdatedAt(state, at) {
      state.updatedAt = at;
    },
    setCustomerName(state, email) {
      state.customerName = email;
    }
  },
  actions: {
    fetchSample(context) {
      return axios.get('admin/samples/sample', {
        params: {
          SampleId: context.state.sampleId
        }
      })
        .then((res) => {
          if (res.status === 404) {
            router.push({ name: 'admin.samples.view' });
          } else if (res.status === 200) {
            context.commit('setStatus', res.data.result.status);
            context.commit('setCustomerName', res.data.result.customerName);
            context.commit('setUpdatedAt', res.data.result.updatedAt);
            Promise.resolve(true);
          }
        }).catch(() => {
          router.push({ name: 'admin.dashboard' });
        });
    },
    resetContext(context) {
      context.commit('setStatus', 1);
      context.commit('setCustomerName', '');
      context.commit('setUpdatedAt', '');
    }
  },
  namespaced: true
};

export default sampleDetail;
